import { FC } from "react";
import { useSelector } from "react-redux";
import { selectUserProfileImage } from "../../slices/user-slice";

const ProfileImage: FC = () => {
    const profileImage = useSelector(selectUserProfileImage(null, true));
    return (
        <div className="relative w-[41px] dmax2:w-[32px] h-[41px] dmax2:h-[32px]">
            <img
                src={profileImage}
                alt="user-photo"
                className="rounded-full cursor-pointer object-cover w-full h-full"
            />
        </div>
    );
};

export default ProfileImage;
